import { generateCodeVerifier, OAuth2Client } from '@badgateway/oauth2-client';

import { openPopupWindow } from './popup-window';

const OAUTH_STATE_KEY = 'oauth-code-verifier';

export async function getOAuthTokenViaPopup(
  client: OAuth2Client,
  redirectUri: string,
  scope: string[],
) {
  const authUrl = await getAuthUrl(client, redirectUri, scope);
  const codeRedirectUrl = await openOAuthPopup(authUrl);
  if (!codeRedirectUrl) return null;
  return getOAuthTokenFromUrl(client, redirectUri, codeRedirectUrl);
}

async function getAuthUrl(client: OAuth2Client, redirectUri: string, scope: string[]) {
  const state = generateState();
  const codeVerifier = await generateCodeVerifier();
  sessionStorage.setItem(OAUTH_STATE_KEY, `${state}:${codeVerifier}`);

  return client.authorizationCode.getAuthorizeUri({
    redirectUri,
    state,
    codeVerifier,
    scope,
  });
}

async function openOAuthPopup(authUrl: string) {
  const popup = openPopupWindow(authUrl, 'oauth-popup', 'width=500,height=600');
  if (!popup) return;
  return popup.waitForFirst(
    popup.waitForWindowClose(),
    popup.waitForUrlMessage(window.location.origin),
  );
}

function generateState(length = 32) {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return btoa(String.fromCharCode(...array))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function getOAuthTokenFromUrl(client: OAuth2Client, redirectUri: string, codeRedirectUrl: URL) {
  const oauthState = sessionStorage.getItem(OAUTH_STATE_KEY);
  if (!oauthState) {
    throw new Error(`No OAuth state for "${OAUTH_STATE_KEY}" key`);
  }
  const [state = '', codeVerifier = ''] = oauthState.split(':');

  return client.authorizationCode.getTokenFromCodeRedirect(codeRedirectUrl, {
    redirectUri,
    state,
    codeVerifier,
  });
}
